export default function GamepadInSquare(props) {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="48" height="48" rx="5.33333" fill="#FFFBEB" />
      <path
        d="M32.6218 19.539C32.4734 18.7615 32.0404 18.0672 31.4073 17.592C30.7743 17.1167 29.9867 16.8947 29.1987 16.9692C28.4106 17.0438 27.6787 17.4096 27.146 17.9951C26.6133 18.5806 26.3181 19.3438 26.3182 20.1354H22.6818C22.6819 19.3438 22.3867 18.5806 21.854 17.9951C21.3213 17.4096 20.5894 17.0438 19.8013 16.9692C19.0133 16.8947 18.2257 17.1167 17.5927 17.592C16.9596 18.0672 16.5266 18.7615 16.3782 19.539C16.3782 19.539 14.5 28.9427 14.5 29.2263C14.5 29.7085 14.6916 30.171 15.0325 30.5119C15.3735 30.8529 15.836 31.0445 16.3182 31.0445C16.7 31.0233 17.0698 30.903 17.3909 30.6954L22.6818 27.4081H26.3182L31.6091 30.6954C31.926 30.9118 32.2982 31.0329 32.6818 31.0445C33.164 31.0445 33.6265 30.8529 33.9675 30.5119C34.3084 30.171 34.5 29.7085 34.5 29.2263C34.5 28.9427 32.6218 19.539 32.6218 19.539Z"
        stroke="#B45309"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
